// extracted by mini-css-extract-plugin
module.exports = {"social-links-menu":"-z_E1"};